import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WarrantiesService } from '../../service/warranties.service';
import { IssueWarrantyDTO } from '../interfaces/warranty.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-construccion-warrantie',
  templateUrl: './modal-construccion-warrantie.component.html',
  styleUrl: './modal-construccion-warrantie.component.scss'
})
export class ModalConstruccionWarrantieComponent {
  public formUpdate: FormGroup;
  public estados = [{value:true, text:'Si'},{value:false, text:'No'}];
  public garantia: IssueWarrantyDTO;

  constructor(private dialogRef: MatDialogRef<ModalConstruccionWarrantieComponent>, private fb: FormBuilder, private warrantiesService: WarrantiesService, @Inject(MAT_DIALOG_DATA)public data: any )
  {
    this.garantia = data;
    this.formUpdate = this.fb.group({
      state: new FormControl(data.isConstruccion, [Validators.required])
    });
  }

  ngOnInit(): void {

  }

  public submit() {
    const {state} = this.formUpdate.value;
    this.warrantiesService.putWarrantieBuild(this.garantia, state).subscribe({
      next:(res) =>{
        Swal.fire({
          title: 'Operación exitosa',
          text: res.message,
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((r) => {
          if(r.isConfirmed) {
            this.dialogRef.close(true);
          }
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Operación fallida',
          text: err.error.resultMessage || 'Ha ocurrido un error inesperado',
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        })
      }
    })
  }

}